module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }} {{ $ctrl.messageService.class }}\" ng-if=$ctrl.messageService.display> <p ng-bind-html=$ctrl.messageService.display></p> <a class=c-message__link ng-if=$ctrl.messageService.displaylink ui-sref={{$ctrl.messageService.displaylink}}> {{$ctrl.messageService.displaylinktext}} </a> <button ng-if=$ctrl.closable type=button class=close data-ng-click=$ctrl.messageService.clear()>×</button> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/message.html
// module id = 499
// module chunks = 0